import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const UpdateProviderBillingCard = (APIData) => async () => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/provider/billing/card`,
      data: APIData,
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error?.response?.data?.message || error.message };
  }
};


